import { FaTimes } from "react-icons/fa";

function SelectedSongsItem({ song, newSongs, setNewSongs }) {
    const removeSong = (title) => {
        setNewSongs(newSongs.filter((song) => song.title !== title));
    };

    return (
        <div
            style={{
                // width: "100%",
                maxWidth: "400px",
                flexGrow: 1,
                borderRadius: "0.5vh",
                overflow: "hidden",
                border: "1px solid #2a3854",
                padding: "1vh",
                backgroundColor: "#2a3854",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: "row",
                position: "relative",
                transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#4db193";
                e.currentTarget.style.backgroundColor = "#1a2d3a";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#2a3854";
                e.currentTarget.style.backgroundColor = "#2a3854";
            }}
        >
            <div style={{ flex: 1, minWidth: 0 }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: "0.8vh",
                        gap: "0.5vh",
                    }}
                >
                    <div
                        style={{
                            fontSize: 14,
                            fontWeight: 500,
                            marginBottom: "0.2vh",
                            color: "white",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            // width: "100%",
                            textAlign: "left",
                        }}
                    >
                        {song.title}
                    </div>
                    <div
                        style={{
                            fontSize: 14,
                            fontWeight: 500,
                            color: "#9ca3af",
                        }}
                    >
                        -
                    </div>
                    <div
                        style={{
                            fontSize: 14,
                            color: "#9ca3af",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            // width: "100%",
                            textAlign: "left",
                        }}
                    >
                        {song.artist}
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "0.3vh",
                        alignItems: "flex-start",
                    }}
                >
                    {song.text?.split(/\s+/).map((word, index) => (
                        <div
                            key={index}
                            style={{
                                backgroundColor: "#161f33",
                                border: "1px solid #2a3854",
                                borderRadius: "0.3vh",
                                padding: "0.3vh 0.6vh",
                                fontSize: 11,
                                color: "#b8c5d1",
                                display: "inline-block",
                            }}
                        >
                            {word}
                        </div>
                    ))}
                </div>
            </div>
            <div
                onClick={(e) => {
                    e.stopPropagation();
                    removeSong(song.title);
                }}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "1vh",
                    flexShrink: 0,
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    backgroundColor: "transparent",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#dc2626";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                }}
            >
                <FaTimes color="#9ca3af" size={12} />
            </div>
        </div>
    );
}

export default SelectedSongsItem;
